/**
 * The `documentType` column on case_files records which screen the file was
 * uploaded from (not what kind of document it is — that's the `label` field).
 */
export type UploadSource =
  | "accessioning"
  | "pathology_review"
  | "case_details"
  | "legacy_report";

interface UploadSourceBadge {
  label: string;
  color: string;
}

export function getUploadSourceBadge(
  documentType: string | null | undefined
): UploadSourceBadge {
  switch (documentType) {
    case "legacy_report":
      return { label: "Legacy report", color: "blue" };
    case "pathology_review":
      return { label: "Pathology Review", color: "violet" };
    case "case_details":
      return { label: "Case Details", color: "gray" };
    case "accessioning":
    default:
      return { label: "Accessioning", color: "blue" };
  }
}
